import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { getItemsOnPage, getPagesNum } from 'ud-ui/components/category/utils';

const state = createSelector(
  (root: RootState) => root.tourneys.availableTournaments,
  (state) => state,
);

export const selectLoading = createSelector([state], (state) => ({
  isLoading: state.isLoading,
  isLoaded: state.isLoaded,
}));

export const selectAvailableTournamentsByFilter = createSelector([state], (state) =>
  Boolean(state.filter.text) ? state.filter.items : state.tournaments,
);

export const selectAvailableTournamentsOnPage = (page: number, perPage: number) =>
  createSelector([selectAvailableTournamentsByFilter], (tournaments) => {
    return getItemsOnPage(tournaments, page, perPage || 1);
  });

export const selectAvailableTournamentsPagination = (perPage: number) =>
  createSelector([state], (state) => {
    const pages = Math.max(1, getPagesNum(state.tournaments.length, perPage || 1));
    return {
      pages,
      allItemsCount: state.tournaments.length,
      limit: state.limit,
      allDataLoaded: state.allDataLoaded,
    };
  });

export const selectError = createSelector([state], (state) => state.error);

export const selectFilter = createSelector([state], (state) => state.filter);

export const selectUserId = createSelector([state], (state) => state.userId);
